const translations = {
  cta: "Full plan",
  title: "From your Care Plan"
};

export default translations;
